export default "__VITE_ASSET__DKwDm6ZS__"